import { Col, Row } from "antd";
import { HTMLAttributes } from "react";
import { Carousel } from "react-bootstrap";
import { CompanyCard } from "../../components";
import { ScreenSize, useMedia } from "../../hooks";
import { AboutSectionCarousel, PartnerContainer } from "./styles/about-section";

const Audience = require("../../assets/images/audience.webp");
const DatabricksLogo = require("../../assets/images/databricks.png");
const IEEELogo = require("../../assets/images/ieee.png");
const AlgasLogo = require("../../assets/images/algas.png");
const EdgeLogo = require("../../assets/images/edge.png");
const GenesysLogo = require("../../assets/images/genesys.png");
const TqaddamLogo = require("../../assets/images/twaddam.webp");
const TiecLogo = require("../../assets/images/tiec.png");
const QabilahLogo = require("../../assets/images/qabilah.png");
const PlugPlayLogo = require("../../assets/images/plug_play.png");
const WrkplusLogo = require("../../assets/images/wrkplus.png");
const CreativaLogo = require("../../assets/images/creativa.png");
const BlossomLogo = require("../../assets/images/blossom.png");

// Dynamically import gallery images
const galleryImages = Array.from({ length: 12 }, (_, i) => require(`../../assets/images/gallery/gallery${i + 1}.jpg`));
console.log(galleryImages);

export const AboutSection: React.FC<HTMLAttributes<HTMLDivElement>> = () => {
    const aboveSM = useMedia(ScreenSize.SM);
    return (
        <section id="about" style={{ width: "100%" }}>
            <Row
                gutter={24}
                className="d-flex align-items-center"
                style={{ backgroundColor: "#000", maxHeight: "1270px" }}
            >
                <Row className="w-100 mb-5">
                    <img style={{ width: "100%" }} loading="lazy" alt="Audience" src={Audience} />
                </Row>
                <Row className="d-flex justify-content-center justify-content-md-around w-100">
                    <h2 className="mb-4">About JobStack</h2>
                    <div>
                        <ul style={{ lineHeight: 2.5, width: "96%" }}>
                            The largest Tech Community in Middle East & Africa where tech gurus,
                            <br /> entrepreneurs, Investors, and enterprises meet, get your ticket to enjoy:
                            <li>1- Navigating different employer booths, drop off your CV, and apply for vacancies.</li>
                            <li>2- Attending talks about the latest trends in the software industry.</li>
                            <li>3- Networking with top regional technical gurus.</li>
                        </ul>
                    </div>
                </Row>
                <Row>
                    <Col xs={24}>
                        <div style={{ width: "100%", minWidth: "100vw" }} className=" d-flex justify-content-center">
                            <AboutSectionCarousel defaultActiveIndex={0} interval={2000}>
                                {galleryImages.map((image) => (
                                    <Carousel.Item key={image}>
                                        <img src={image} alt="First slide" style={{ objectFit: "contain" }} />
                                    </Carousel.Item>
                                ))}
                            </AboutSectionCarousel>
                        </div>
                    </Col>
                </Row>
            </Row>
            <PartnerContainer gutter={24} className="d-flex align-items-center mt-0 mt-md-5">
                <Col xs={24}>
                    <Row className="mb-0 mb-md-5">
                        <Col xs={24}>
                            <h2 style={{ color: "#000" }} className="mx-3">
                                Previous Strategic Partners
                            </h2>
                            <p style={{ color: "#000", fontWeight: 500, fontSize: "0.9rem" }} className="mx-3">
                                Elevating Tech Innovation Across the MEA Region
                            </p>
                        </Col>
                    </Row>
                    <Row gutter={24} className="d-flex justify-content-center align-items-center">
                        <Col xs={12} md={10}>
                            <CompanyCard imgSource={EdgeLogo} minWidth={aboveSM ? "350px" : "160px"} />
                        </Col>
                        <Col xs={12} md={10} className="mb-5 mb-md-0">
                            <CompanyCard imgSource={AlgasLogo} minWidth={aboveSM ? "180px" : "160px"} />
                        </Col>
                    </Row>
                </Col>
            </PartnerContainer>
            <PartnerContainer gutter={24} className="d-flex align-items-center">
                <Col xs={24}>
                    <Row className="mb-0 mb-md-5">
                        <Col xs={24}>
                            <h2 style={{ color: "#000" }} className="mx-3">
                                Previous Technology Partners
                            </h2>
                        </Col>
                    </Row>
                    <Row gutter={16} className="d-flex justify-content-center">
                        <Col xs={12} md={8} className="mb-5 mb-md-0">
                            <CompanyCard imgSource={GenesysLogo} minWidth={aboveSM ? undefined : "130px"} />
                        </Col>
                        <Col xs={12} md={8}>
                            <CompanyCard imgSource={IEEELogo} minWidth={aboveSM ? undefined : "200px"} />
                        </Col>
                        <Col xs={12} md={8}>
                            <CompanyCard imgSource={DatabricksLogo} minWidth={aboveSM ? undefined : "200px"} />
                        </Col>
                    </Row>
                </Col>
            </PartnerContainer>
            <PartnerContainer gutter={24} className="d-flex align-items-center">
                <Col xs={24}>
                    <Row className="mb-0 mb-md-5">
                        <Col xs={24}>
                            <h2 style={{ color: "#000" }} className="mx-3">
                                Previous Ecosystem Partners
                            </h2>
                        </Col>
                    </Row>
                    <Row gutter={48} className="d-flex justify-content-center">
                        <Col xs={12} md={8} lg={6}>
                            <CompanyCard imgSource={PlugPlayLogo} minWidth={aboveSM ? undefined : "130px"} />
                        </Col>
                        <Col xs={13} md={8} lg={6}>
                            <CompanyCard imgSource={QabilahLogo} minWidth={aboveSM ? undefined : "200px"} />
                        </Col>
                        <Col xs={13} md={8} lg={6}>
                            <CompanyCard imgSource={WrkplusLogo} minWidth={aboveSM ? undefined : "200px"} />
                        </Col>
                        <Col xs={13} md={8} lg={6}>
                            <CompanyCard imgSource={TqaddamLogo} minWidth={aboveSM ? undefined : "200px"} />
                        </Col>
                        <Col xs={13} md={8} lg={6}>
                            <CompanyCard imgSource={CreativaLogo} minWidth={aboveSM ? undefined : "200px"} />
                        </Col>
                        <Col xs={13} md={8} lg={6}>
                            <CompanyCard imgSource={TiecLogo} minWidth={aboveSM ? undefined : "200px"} />
                        </Col>
                        <Col xs={13} md={8} lg={6}>
                            <CompanyCard imgSource={BlossomLogo} minWidth={aboveSM ? undefined : "200px"} />
                        </Col>
                    </Row>
                </Col>
            </PartnerContainer>
        </section>
    );
};
